module.exports = __webpack_public_path__ + "static/media/icon_search-placeholder.b68aa691.svg";